import { sendGet } from './axios';

export const getTextWebPages = () => sendGet(`/text-web-pages`);

